export function  extraServerModel(data) {
    let model = data || {};

    return {
        Name: model.name || "",
        Enabled: model.enabled || false,
        Description: model.description || ""
    }
}